import * as FlexLayout from './src'
export * from './src'
export {FlexLayout}


// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexlayout-react/index.ts